import React from 'react';
import { HubspotLeadInModal } from './hubspotLeadInModal/HubspotLeadInModal';

/**
 * Adds all global styles to the page.
 */
export const GlobalStyles = () => <HubspotLeadInModal />;
